import { createFileRoute } from '@tanstack/react-router';
import { DateTime } from 'luxon';

import { Container, Stack, Typography } from 'gooey';
import { Page } from '#/components/pages';
import fx from '#/fx';
import { Content } from '#/lib/content';
import { canonicalLinkTag, seo } from '#/lib/head';

export const Route = createFileRoute('/_main/legal/$id')({
  loader: async ({ params }) => {
    const page = await fx.getPageContentBySlug({
      data: {
        key: 'legal',
        slug: params.id,
      },
    });

    return { page };
  },
  head: ({ loaderData, match }) => ({
    meta: seo({
      title: loaderData?.page.seo.title ?? 'Legal',
      description: loaderData?.page.seo.description ?? 'A legal page.',
      image: loaderData?.page.seo.image,
      url: match.pathname,
    }),
    links: [canonicalLinkTag(match.pathname)],
  }),
  component: LegalPage,
});

function LegalPage() {
  const { page } = Route.useLoaderData();
  return (
    <Page
      gutter={{
        xs: 10,
        sm: 12,
        md: 16,
      }}
    >
      <Stack direction='column' spacing={1} alignItems='center'>
        <Container>
          <Stack alignItems='center' justifyContent='center' spacing={3}>
            <div className='text-center'>
              <Typography variant='h2' component='h1' gutterBottom>
                {page.title}
              </Typography>
              <Typography variant='body2'>
                Last updated:{' '}
                {DateTime.fromJSDate(new Date(page.modified)).toLocaleString(DateTime.DATE_SHORT)}
              </Typography>
            </div>
          </Stack>
        </Container>
        <Container maxWidth='md' className='mt-8'>
          <Content content={page.content} styling='prose' />
        </Container>
      </Stack>
    </Page>
  );
}
